import React from 'react';
import buildContext from '~/components/jsx-helpers/build-context';
import loadable from 'react-loadable';
import LoadingPlaceholder from '~/components/loading-placeholder/loading-placeholder';
import deepEqual from 'deep-equal';
const loaders = {
    default: () => import('~/layouts/default/default'),
    landing: () => import('~/layouts/landing/landing')
};
const defaultLayoutParameters = { name: 'default' };
function useContextValue() {
    const [layoutParameters, setLayoutParameters] = React.useState(defaultLayoutParameters);
    const updateIfNotEqual = React.useCallback((newValue) => {
        if (newValue === undefined) {
            setLayoutParameters(defaultLayoutParameters);
            return;
        }
        if (deepEqual(layoutParameters, newValue)) {
            return;
        }
        setLayoutParameters(newValue);
    }, [layoutParameters]);
    const LoadableLayout = React.useMemo(() => loadable({
        loader: () => loaders[layoutParameters.name](),
        loading: LoadingPlaceholder
    }), [layoutParameters.name]);
    const Layout = React.useCallback(({ children }) => (React.createElement(LoadableLayout, { data: layoutParameters.data }, children)), [LoadableLayout, layoutParameters.data]);
    return { Layout, setLayoutParameters: updateIfNotEqual, layoutParameters };
}
const { useContext, ContextProvider } = buildContext({ useContextValue });
export { useContext as default, ContextProvider as LayoutContextProvider };
